import { TRADABLES_TYPE } from "@helpers/constants";
import { Tradable as OldTradable } from "@models/interfaces/tradable";
import { Tradable } from "../entities/tradable";
import { CryptocoinAdapter } from "../entities/tradables/cryptocoin";
import { EtfAdapter } from "../entities/tradables/etf";
import { IndexAdapter } from "../entities/tradables";
import { MetalAdapter } from "../entities/tradables/metal";
import { StockAdapter } from "../entities/tradables/stock";
import { EtcAdapter } from "../entities/tradables/etc";
import { LeveragedTokenAdapter } from "../entities/tradables/leveraged_tokens";
import { SecurityTokenAdapter } from "@modules/+new/core/tradables/domain/entities/tradables/security_token";

const tradableMap = {
	[TRADABLES_TYPE.CRYPTO]: CryptocoinAdapter,
	[TRADABLES_TYPE.ETF]: EtfAdapter,
	[TRADABLES_TYPE.ETC]: EtcAdapter,
	[TRADABLES_TYPE.INDEX]: IndexAdapter,
	[TRADABLES_TYPE.METAL]: MetalAdapter,
	[TRADABLES_TYPE.STOCK]: StockAdapter,
	[TRADABLES_TYPE.LEVERAGED_TOKEN]: LeveragedTokenAdapter,
	[TRADABLES_TYPE.SECURITY_TOKEN]: SecurityTokenAdapter
};

export class TradablesFactory {
	public static createTradable(tradable: OldTradable): Tradable {
		const type = tradable.getCurrencyType();
		return new tradableMap[type]().adapt(tradable);
	}
}
